import * as React from 'react';
import { Container } from 'types/Watchlist';
import {
  formatPickupLocationPort,
  formatPickupLocationTerminal,
  formatScheduledAppointment,
} from 'utils/container-transforms';
import { Row, RowGroup } from '../components';

interface Props {
  container: Container;
}

export const Pickup: React.FC<Props> = (props) => {
  const { container } = props;

  const closedArea = container.pickupInfo?.yardLocation?.closedArea;
  let closedAreaLabel = '';
  if (closedArea === true) {
    closedAreaLabel = 'Yes';
  } else if (closedArea === false) {
    closedAreaLabel = 'No';
  }

  return (
    <RowGroup label="Pickup">
      <Row label="Port of Destination">{formatPickupLocationPort(container)?.value}</Row>
      <Row label="Pickup Location">{formatPickupLocationTerminal(container)?.value}</Row>
      <Row label="Appointment Scheduled">{formatScheduledAppointment(container)?.value}</Row>
      <Row label="Drayage Carrier">{container.gatedOut?.drayageScac}</Row>
      <Row label="Yard location">{container.pickupInfo?.yardLocation.location}</Row>
      <Row label="Closed Area">{closedAreaLabel}</Row>
    </RowGroup>
  );
};
Pickup.displayName = 'Shipments.DetailDrawer.Sections.Availability.Pickup';
